import { Button as MUIButton, Tooltip, Box } from '@mui/material';
import styled from 'styled-components';

export const Title = styled.p`
  font-weight: bold;
`;

export const BtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    justify-content: flex-start;
    align-items: start;
    flex: 1;

    .btnResponsive {
      flex: 1;
      width: 100%;
    }
  }
`;

export const FixedButton = styled(MUIButton)``;

export const FieldsInLineLayout = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
  }
`;

export const InputContainerWidthNumber = styled.div`
  width: 300px;
  min-width: 110px;
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex: 1;
    flex-direction: column;
    align-items: start;

    .btnResponsive {
      flex: 1;
      width: 100%;
    }
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 15px;
`;
